import tailwindConfig from 'tailwindConfig';

function useTailwindTheme() {
    return tailwindConfig?.theme;
}

export default useTailwindTheme;
